"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChannelsData = exports.useChannelData = exports.ChatService = void 0;
var ChatService_1 = __importDefault(require("./src/ChatService"));
exports.ChatService = ChatService_1.default;
var useChannelData_1 = require("./src/useChannelData");
Object.defineProperty(exports, "useChannelData", { enumerable: true, get: function () { return useChannelData_1.useChannelData; } });
var useChannelsData_1 = require("./src/useChannelsData");
Object.defineProperty(exports, "useChannelsData", { enumerable: true, get: function () { return useChannelsData_1.useChannelsData; } });
//# sourceMappingURL=index.js.map